import { createApp } from "vue";
import App from "./App.vue";

import router from "./router/index";

import store from "./store";

// import BootstrapVue3 from "bootstrap-vue-3"; //bootstrap-vue-3會與bootstrap5的js衝突，暫不使用
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
// import "bootstrap-vue-3/dist/bootstrap-vue-3.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHouse,
  faArrowRightLong,
  faDisplay,
  faAngleUp,
  faAngleDown,
  faSquare,
  faFile,
  faExclamation,
  faExclamationTriangle,
  faCogs,
  faChartLine,
  faVectorSquare,
  faCheck,
  faXmark,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
  faHouse,
  faArrowRightLong,
  faDisplay,
  faAngleUp,
  faAngleDown,
  faSquare,
  faFile,
  faExclamation,
  faExclamationTriangle,
  faCogs,
  faChartLine,
  faVectorSquare,
  faCheck,
  faXmark,
  faTrashCan
);

import axios from "axios";
import VueAxios from "vue-axios";

import { childRouter } from "@/router/childRouter";
router.addRoute(...childRouter);

createApp(App)
  //整個應用支援路由
  .use(router)
  .use(store)
  .use(VueAxios, axios)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");

router.beforeEach((to, from, next) => {
  console.log(to);
  const loginData = store.getters["getLogin/get_loginData"];
  const sideBar = store.getters["sideBarTree/get_sideBar"];

  if (to.name == "singleWorkOrderHistory" || to.name == "demoPlugin") {
    next();
    return;
  }
  if (to.name == "login") {
    next();
  } else if (to.name == "404") {
    next();
  } else {
    const accessListArray = Object.keys(sideBar);
    if (accessListArray) {
      if (loginData.accessList == "ALL") {
        if (router.hasRoute(to.name)) {
          next();
        } else {
          next("/login");
        }
      } else if (loginData.status != true) {console.log(to);
        next("/login");
      } else {
        if (accessListArray.indexOf(to.name) == -1) {console.log(to);
          next("/login");
        } else {
          next();
        }
      }
    } else {console.log(to);
      next("/login");
    }
  }
});
